import { render } from "./AdminArtistList.vue?vue&type=template&id=30930c0a"
import script from "./AdminArtistList.vue?vue&type=script&lang=js"
export * from "./AdminArtistList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__